<div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: '50vh';">
    <p-progressSpinner></p-progressSpinner>
</div>